module.exports = __webpack_public_path__ + "statics/img/01.9b72b2fb.png";